import './contentSlider';
import './photolab.dropzone';
import './quotes';
import './homepage';
import './photos_favourites';
